@if(control){
<div
  class="basic-input tw-box-border tw-font-inter"
  [ngClass]="{
    '!tw-p-0': mode === BasicInputMode.INLINE
  }"
  [style.padding.px]="fieldType === basicFieldType.UPLOAD ? '5px 0 0' : '5px 0 25px'"
>
  @if(fieldType !== basicFieldType.SELECT) {
  <div class="tw-relative tw-group">
    @if(fieldType === basicFieldType.SLUG) {
    <span
      [ngClass]="{
        'tw-opacity-100': isFocused || control.value,
        'tw-opacity-0': !isFocused
      }"
      (click)="input.focus()"
      class="slug-text tw-text-sm tw-z-10 tw-absolute tw-top-1/2 -tw-translate-y-1/2 tw-start-9 tw-flex tw-items-center tw-text-slate-500"
      dir="auto"
    >
      {{ prefixSlug }}
    </span>
    }
    <input
      [autocomplete]="autocomplete"
      #input
      [readonly]="readOnly"
      [min]="min"
      [max]="max"
      [ngClass]="{
          '!tw-border-none tw-rounded-[4px]  placeholder:!tw-opacity-100 !tw-py-0 !tw-text-base inline-input': mode === BasicInputMode.INLINE,
          '!tw-bg-red-200 dark:!tw-bg-red-800': mode === BasicInputMode.INLINE && control.invalid && control.touched,
          'hover:!tw-bg-gray-100 dark:hover:!tw-bg-gray-700': mode === BasicInputMode.INLINE && !(control.invalid && control.touched) ,
          'focus:!tw-bg-gray-200 dark:focus:!tw-bg-gray-600': mode === BasicInputMode.INLINE && isFocused,
          '!tw-border-red-600 dark:!tw-border-red-500 hover:!tw-border-red-700': control.invalid && !control.disabled && control.touched,
          '!tw-border-green-600 dark:!tw-border-green-500 hover:!tw-border-green-700': mode !== BasicInputMode.INLINE && control.valid && !control.disabled && !!control.value && control.touched && addValidationColors,
          'tw-px-9': icon && fieldType !== basicFieldType.PHONE && fieldType !== basicFieldType.DATE,
          '!tw-px-12': fieldType === basicFieldType.PHONE,
          '!tw-px-9':fieldType === basicFieldType.PHONE && mode === BasicInputMode.INLINE,
          '!tw-px-10':mode === BasicInputMode.INLINE && icon && fieldType === basicFieldType.PHONE,
          '!tw-px-1':mode === BasicInputMode.INLINE && !icon,
          '!tw-px-[30px]':mode === BasicInputMode.INLINE && icon && fieldType !== basicFieldType.PHONE,
          'placeholder:tw-text-gray-300 dark:placeholder:!tw-text-gray-400': control.value || (!control.value && control.touched && !control.validator ),
          'placeholder:!tw-opacity-0':  fieldType === basicFieldType.URL && prefixSlug && isFocused && mode === BasicInputMode.INLINE,
          'not-empty': control.value,
          'tw-rounded-lg': mode !== BasicInputMode.INLINE,
          'tw-cursor-pointer': readOnly && mode !== BasicInputMode.INLINE,
        }"
      [style.height.px]="fieldType === basicFieldType.UPLOAD ? 22 : mode === BasicInputMode.INLINE ? 36 : 58"
      [style.background]="fieldType === basicFieldType.UPLOAD ? 'transparent' : ''"
      [style.color]="fieldType === basicFieldType.UPLOAD ? '#fff' : ''"
      [formControl]="control"
      [type]="type"
      [id]="inputId"
      class="tw-bg-transparent tw-outline-none tw-font-inter placeholder:tw-text-gray-500 dark:placeholder:!tw-text-gray-400 tw-px-4 placeholder:tw-text-base tw-w-full focus:tw-ring-0 tw-text-sm tw-text-gray-900 dark:tw-text-white tw-font-medium tw-peer tw-py-5 tw-box-border tw-border tw-border-1 tw-border-gray-300 dark:tw-border-gray-600 tw-cursor-auto focus:tw-border-2 hover:tw-border-blue-700 dark:hover:tw-border-blue-600 focus:tw-border-blue-600 dark:focus:tw-border-blue-500 focus:tw-shadow-none"
      [placeholder]="placeholder"
      (blur)="onBlur($event)"
      (input)="fieldType === basicFieldType.PHONE ? onPhoneInput($event) : onChange($event)"
      (focus)="onFocus($event)"
      (wheel)="onWheelEvent($event)"
      (keydown)="$event.stopPropagation(); onKeydownEvent($event)"
    />

    @if((fieldType === basicFieldType.PHONE && !image) || (icon && !image) || (!control.value && icon)) {
    <span
      [innerHTML]="sanitizeSVG(icon)"
      class="span-icon tw-absolute tw-top-1/2 -tw-translate-y-1/2 tw-start-3 tw-flex tw-items-center"
      [ngClass]="{
        'fill-icon': iconType === 'fill' && (addValidationColors || control.invalid),
        'stroke-icon': iconType === 'stroke' && (addValidationColors || control.invalid),
        '!tw-start-1': mode === BasicInputMode.INLINE
      }"
    ></span>
    } @if(fieldType === basicFieldType.PHONE && control.value && image) {
    <span>
      <img
        (click)="input.focus()"
        [src]="image"
        alt="country-flag"
        [ngClass]="{
          '!tw-start-1 !tw-w-[18px] !tw-h-[18px] !tw-rounded-full': mode === BasicInputMode.INLINE
        }"
        class="flag tw-absolute tw-top-1/2 -tw-translate-y-1/2 tw-start-3 tw-flex tw-items-center"
      />
    </span>
    } @if(fieldType === basicFieldType.PHONE) {
    <span
      (click)="input.focus()"
      class="tw-plus tw-absolute tw-top-1/2 -tw-translate-y-1/2 tw-start-10 tw-flex tw-items-center tw-text-sm tw-font-medium"
      [ngClass]="{
        'tw-text-gray-500 dark:tw-text-gray-400': control.untouched && !control.value,
        'tw-text-gray-700 dark:tw-text-gray-400': control.untouched && control.value,
        'tw-start-6': mode === BasicInputMode.INLINE
      }"
    >
      +
    </span>
    } @if(mode !== BasicInputMode.INLINE) {
    <label
      [for]="inputId"
      (click)="input.focus()"
      class="tw-absolute group-hover:tw-cursor-text tw-text-sm tw-font-medium tw-leading-[21px] tw-select-none tw-duration-300 tw-transform -tw-translate-y-4 tw-scale-75 tw-origin-[0] tw-px-1 peer-focus:tw-top-1 peer-focus:tw-start-2 peer-focus:tw-scale-75 peer-focus:-tw-translate-y-4 field-label"
      [ngClass]="{
        'tw-text-gray-500 dark:!tw-text-gray-400': control.untouched && !control.value && fieldType !== basicFieldType.UPLOAD && !isFocused,
        'tw-text-gray-700 dark:!tw-text-gray-400': ((control.untouched && control.value) || control.status === 'PENDING') && fieldType !== basicFieldType.UPLOAD,
        '!tw-text-blue-700 peer-hover:!tw-text-blue-800': isFocused && !control.value && control.touched,
        '!tw-text-green-600 peer-hover:!tw-text-green-700': control.valid && !!control.value && control.touched && addValidationColors,
        '!tw-text-red-600 dark:!tw-text-red-500 peer-hover:!tw-text-red-700': control.invalid && control.touched && fieldType !== basicFieldType.UPLOAD,
        'tw-placeholder-shown:tw-start-9 tw-start-9': icon && !control.value,
        'tw-placeholder-shown:tw-start-2 tw-start-2': icon && control.value,
        'tw-top-1 tw-scale-75 -tw-translate-y-4': control.value || control.value === 0,
        'tw-top-1/2 -tw-translate-y-1/2 tw-scale-100': !control.value && control.value !== 0,
        'tw-start-9': icon && !control.value,
        'tw-start-2': (icon && control.value) || control.value || !control.value,
        'tw-bg-white dark:!tw-bg-gray-800 peer-focus:tw-text-gray-700 dark:peer-focus:tw-text-gray-300 tw-text-gray-500 dark:tw-text-gray-400': fieldType !== basicFieldType.UPLOAD,
        'peer-focus:tw-bg-gray-800 dark:peer-focus:tw-bg-gray-700 peer-focus:tw-text-blue-700 dark:peer-focus:tw-text-blue-400 tw-text-blue-700 dark:tw-text-blue-400':
          fieldType === basicFieldType.UPLOAD,
        'peer-focus:tw-bg-white dark:peer-focus:tw-bg-gray-800 peer-focus:tw-text-blue-700  !tw-text-blue-700 dark:peer-focus:tw-text-blue-400':
          isFocused && !control.dirty && !control.touched && !control.value,
        'tw-bg-gray-700 dark:tw-bg-gray-600': fieldType === basicFieldType.UPLOAD && control.value
      }"
    >
      {{ label }}
      @if(required) {
      <span class="tw-text-red-500">*</span>
      }
    </label>
    } @if(isLoading) {
    <progress-circle class="tw-p-1 tw-absolute tw-top-1/2 -tw-translate-y-1/2 tw-end-3"></progress-circle>
    }@else { @if((fieldType !== basicFieldType.PASSWORD && fieldType !== basicFieldType.DATE) && allowClearButton){
    <button
      type="button"
      tabindex="-1"
      class="clear-icon tw-p-1 tw-absolute tw-top-1/2 -tw-translate-y-1/2 tw-end-3 tw-cursor-pointer tw-fill-transparent peer-focus:tw-stroke-gray-700"
      (mouseup)="resetControl()"
    >
      <svg
        class="tw-w-2.5 tw-h-2.5 tw-text-gray-500 group-hover:tw-text-gray-700 dark:tw-text-gray-500 dark:group-hover:tw-text-gray-400"
        viewBox="0 0 14 14"
        [ngClass]="{
            'tw-stroke-gray-500 hover:tw-stroke-gray-600': control.untouched,
          }"
      >
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
      </svg>
    </button>
    } @if(fieldType === basicFieldType.PASSWORD && type === 'text'){
    <button type="button" tabindex="-1" class="span-icon tw-p-1 tw-absolute tw-top-1/2 tw-end-3 tw-cursor-pointer -tw-translate-y-1/2" (click)="type = 'password'">
      <svg class="tw-w-2.5 tw-h-2.5 tw-fill-gray-500 group-hover:tw-fill-gray-400" viewBox="0 0 20 20">
        <path
          d="m2 13.587 3.055-3.055A4.913 4.913 0 0 1 5 10a5.006 5.006 0 0 1 5-5c.178.008.356.026.532.054l1.744-1.744A8.973 8.973 0 0 0 10 3C4.612 3 0 8.336 0 10a6.49 6.49 0 0 0 2 3.587Z"
        />
        <path
          d="m12.7 8.714 6.007-6.007a1 1 0 1 0-1.414-1.414L11.286 7.3a2.98 2.98 0 0 0-.588-.21l-.035-.01a2.981 2.981 0 0 0-3.584 3.583c0 .012.008.022.01.033.05.204.12.401.211.59l-6.007 6.007a1 1 0 1 0 1.414 1.414L8.714 12.7c.189.091.386.162.59.211.011 0 .021.007.033.01a2.981 2.981 0 0 0 3.584-3.584c0-.012-.008-.023-.011-.035a3.05 3.05 0 0 0-.21-.588Z"
        />
        <path d="M17.821 6.593 14.964 9.45a4.952 4.952 0 0 1-5.514 5.514L7.665 16.75c.767.165 1.55.25 2.335.251 6.453 0 10-5.258 10-7 0-1.166-1.637-2.874-2.179-3.407Z" />
      </svg>
    </button>
    } @if(fieldType === basicFieldType.PASSWORD && type === 'password'){
    <button
      type="button"
      tabindex="-1"
      class="span-icon tw-p-1 password-btn tw-absolute tw-top-1/2 -tw-translate-y-1/2 tw-end-3 tw-cursor-pointer tw-fill-gray-500"
      (click)="type = 'text'"
    >
      <svg class="tw-w-2.5 tw-h-2.5 tw-text-gray-500 group-hover:tw-text-gray-700 dark:tw-text-gray-500 dark:group-hover:tw-text-gray-400" viewBox="0 0 20 14">
        <path d="M10 0C4.612 0 0 5.336 0 7c0 1.742 3.546 7 10 7 6.454 0 10-5.258 10-7 0-1.664-4.612-7-10-7Zm0 10a3 3 0 1 1 0-6 3 3 0 0 1 0 6Z" />
      </svg>
    </button>
    } }
  </div>
  } @if(fieldType === basicFieldType.SELECT) {
  <ng-container>
    <div class="tw-font-inter tw-text-sm tw-w-full tw-h-15 tw-rounded-xl">
      <ng-content></ng-content>
    </div>
  </ng-container>
  } @if(isFullname && fullnameParts.fullnameSegments.length > 0 && mode !== BasicInputMode.INLINE && (isFocused || (control.value && control.valid)) || (!isFocused && control.value
  && control.valid)) {
  <!-- Full name segmentation logic -->
  <div class="tw-w-[500px] tw-opacity-0 tw-absolute tw-left-[99999px]">
    <div class="subtext-container tw-flex">
      @for(subtext of fullnameParts?.fullnameSegments; track subtext) {
      <div [id]="getUniqueId(subtext)">
        <div class="tw-leading-[20px] tw-font-normal tw-text-base">
          {{ fullnameParts.processString[subtext] || '' }}
        </div>
      </div>
      }
    </div>
  </div>

  <!-- Displayed full name segments -->
  <div class="tw-max-w-[570px] tw-max-h-4 segments-container tw-relative">
    @for(subtext of fullnameParts.fullnameSegments; track subtext) {
    <div
      class="tw-absolute tw-leading-[17px] tw-text-[10px]"
      [ngStyle]="{
        'left.px': getSegmentPosition(subtext),
        'width.px': getSegmentWidth(subtext)
      }"
    >
      <div class="tw-truncate tw-text-center segment-border">
        {{ subtext === 'salutations' ? (subtext | SegmentPipe) : (subtext | SegmentPipe : 60) }}
      </div>
    </div>
    }
  </div>
  } @if (control.invalid && control.touched && !(isFullname && fullnameParts.fullnameSegments.length > 0 && isFocused)) {
  <div
    class="tw-text-red-600 dark:!tw-text-red-500 tw-font-inter tw-text-xs error-message"
    [ngClass]="{
      'select-input-error': fieldType === basicFieldType.SELECT,
      '!tw-top-[41px] tw-text-sm !tw-static': mode === BasicInputMode.INLINE,
      'tw-ml-[30px]': (mode === BasicInputMode.INLINE && icon) || (mode === BasicInputMode.INLINE && fieldType === basicFieldType.SELECT && icon)
    }"
  >
    <div>{{ getErrorMessage() }}</div>
  </div>
  }
</div>
}
